export default __webpack_public_path__ + "static/media/canvas-blue.28a08556.webp";